module.exports = __webpack_public_path__ + "img/768_stores_img1.5e8b12a7.png";